
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.097 15.561A4.265 4.265 0 014.44 17.6v0a4.265 4.265 0 01-2.04-5.66l1.294-2.748a4.264 4.264 0 015.658-2.038v0a4.252 4.252 0 012.35 2.986","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.34 4.439A4.265 4.265 0 0115 2.4a4.266 4.266 0 012.038 5.658l-1.293 2.749a4.265 4.265 0 01-5.659 2.038v0a4.241 4.241 0 01-2.2-2.451","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    